import { useState, useEffect } from 'react';
import Header from './ui/Header';
import GameBoard from './game/GameBoard';
import Keyboard from './keyboard/Keyboard';
import GameController from './game/GameController';
import HelpModal from './modals/HelpModal';
import StatsModal from './modals/StatsModal';
import PrivacyModal from './modals/PrivacyModal';
import SettingsModal from './modals/SettingsModal';
import Footer from './Footer';
import { useGame } from '../contexts/GameContext';
import './Game.css';

function Game() {
  const { state } = useGame();
  const [showHelp, setShowHelp] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  // Auto-show stats modal when game ends
  useEffect(() => {
    if (state.gameState === 'won' || state.gameState === 'lost') {
      // Wait for tile flip animations to complete (2 seconds)
      const timer = setTimeout(() => {
        setShowStats(true);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [state.gameState]);

  return (
    <div className="game">
      <Header
        onHelpClick={() => setShowHelp(true)}
        onStatsClick={() => setShowStats(true)}
        onSettingsClick={() => setShowSettings(true)}
      />

      <div className="game-container">
        {state.error && (
          <div className="error-message">{state.error}</div>
        )}

        <GameBoard />
        <Keyboard />
      </div>

      <GameController />

      <HelpModal
        isOpen={showHelp}
        onClose={() => setShowHelp(false)}
      />

      <StatsModal
        isOpen={showStats}
        onClose={() => setShowStats(false)}
      />

      <PrivacyModal
        isOpen={showPrivacy}
        onClose={() => setShowPrivacy(false)}
      />

      <SettingsModal
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
      />

      <Footer onPrivacyClick={() => setShowPrivacy(true)} />
    </div>
  );
}

export default Game;